import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import LoginPage from "./Pages/LoginPage/LoginPage";
import RankProjects from './Pages/RankProjects/RankProjects';
import ClassSelect from './Pages/ClassSelect/ClassSelect';
import ClassView from './Pages/ClassView/ClassView';
import StudentHome from './Pages/StudentHome/StudentHome';
import StudentTeamView from './Pages/StudentTeamView/StudentTeamView';
import GroupFormation from './Pages/GroupFormation/GroupFormation';
import Assignment1 from './Pages/Assignment1/Assignment1';
import ProjectSubmission from './Pages/ProjectSubmission/ProjectSubmission';
import Placeholder from './Pages/Placeholder/Placeholder';
import RegisterRequest from './Pages/Register/RegisterRequest';
import RegisterUser from './Pages/Register/RegisterUser';
import StudentInformation from './Pages/StudentInformation/StudentInformation';
import FormsView from './Pages/FormsView/FormsView';
import AssignmentView from './Pages/AssignmentView/AssignmentView';
import ClassAssignments from './Pages/ClassAssignments/ClassAssignments';
import AssignmentResponses from './Pages/AssignmentResponses/AssignmentResponses';
import PublicHomePage from './Pages/PublicSite/PublicHomePage';
import PublicProjects from './Pages/PublicSite/PublicProjects';
import ProjectViewPage from './Components/PublicSite/ProjectViewPage';
import EditPublicSite from './Pages/EditPublicSite/EditPublicSite';

function App() {
  return(
     <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Routes>
              <Route path="/" element={<PublicHomePage />} />
              <Route path="/projects" element={<PublicProjects />} />
              <Route path="/projects/:id" element={<ProjectViewPage />} />
              <Route path="/Login" element={<LoginPage />} />
              <Route path="/rankprojects" element={<RankProjects />} />
              <Route path="/classselect" element={<ClassSelect />} />
              <Route path="/classview" element={<ClassView />} />
              <Route path="/student" element={<StudentHome />} /> 
              <Route path="/team" element={<StudentTeamView />} />
              <Route path="/group_formation" element={<GroupFormation />} />
              <Route path="/assignment1" element={<Assignment1 />} />
              <Route path="/projectsubmission" element={<ProjectSubmission />} />
              <Route path="/placeholder" element={<Placeholder />} />
              <Route path="/register" element={<RegisterRequest />} />
              <Route path="/finalizeRegistration/:accessCode" element={<RegisterUser />} />
              <Route path="/studentinfo" element={<StudentInformation />} />
              <Route path="/forms" element={<FormsView />} />
              <Route path="/assignment" element={<AssignmentView />} />
              <Route path="/assignments" element={<ClassAssignments />} />
              <Route path="/responses" element={<AssignmentResponses />} />
              <Route path="/editpublicsite" element={<EditPublicSite />} />
          </Routes>
      </BrowserRouter>
  )
}
export default App;
